import React, { useState } from "react";
import { LeadViewDetailsViewFullInfoProps } from "./customer-view-details-view-full-info.props";
import "./customer-view-details-view-full-info.scss";
import { formatDateTime } from "../../../../../../utils/utils";
import ContactLink from "../../../../../../common/components/contact-link/contact-link";
import { useLogin } from "../../../../../../common/hooks/useUser";

const LeadViewDetailsViewFullInfo: React.FC<
  LeadViewDetailsViewFullInfoProps
> = (props: any) => {
  const {
    customerDetails,
    viewFullInfoOpen,
    setViewFullInfoOpen,
    permissions,
    isMobile,
  } = props;
  const [isViewOpen, setIsViewOpen] = useState<boolean>(true);
  const handleEditOpen = () => setViewFullInfoOpen(!viewFullInfoOpen);
  const { tenantDetails } = useLogin();
  const checkIsDisableEdit = () => {
    return tenantDetails?.tenantType === "Tenant" &&
      customerDetails?.lead_status === "Closed-Lost" &&
      customerDetails?.lead_source === "AFP"
      ? true
      : false;
  };

  return (
    <div className="customer-list-view-details-view-box-full-info">
      {!isMobile && (
      <div className="customer-list-view-details-view-box-full-info-header">
        <div>Additional Details</div>
        <div>
          {isViewOpen ? (
            <i
              className="fa fa-angle-down"
              onClick={() => {
                setIsViewOpen(!isViewOpen);
              }}
            />
          ) : (
            <i
              className="fa fa-angle-up"
              onClick={() => {
                setIsViewOpen(!isViewOpen);
              }}
            />
          )}
        </div>
      </div>
       )}
      {isViewOpen ? (
        <>
          <div className="customer-list-view-details-view-box-full-info-header-text-edit">
            <div className="customer-list-view-details-view-box-full-info-header-text">
              Customer Information
            </div>
            <div className="customer-list-view-details-view-box-full-info-header-edit">
              <button
                className="customer-list-view-edit-section"
                onClick={handleEditOpen}
                disabled={checkIsDisableEdit() || !permissions?.canWrite}
              >
                Edit
              </button>
            </div>
          </div>
          <div className="customer-list-view-details-view-box-full-info-data">
            <div className="customer-list-view-details-view-box-full-info-data-section">
              <div className="customer-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="customer-list-view-details-view-box-full-info-data-section-main">
                  Secondary Phone Number
                </div>
                <ContactLink
                  type="Phone"
                  value={customerDetails?.secondary_phone_number || "-"}
                  id={customerDetails?.id}
                  className="customer-list-view-details-view-box-full-info-data-section-sub"
                />
              </div>
              <div className="customer-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="customer-list-view-details-view-box-full-info-data-section-main">
                  Fax
                </div>
                <div className="customer-list-view-details-view-box-full-info-data-section-sub">
                  {customerDetails?.fax_number || "-"}
                </div>
              </div>
              <div className="customer-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="customer-list-view-details-view-box-full-info-data-section-main">
                  Assistant
                </div>
                <div className="customer-list-view-details-view-box-full-info-data-section-sub">
                  {customerDetails?.assistant || "-"}
                </div>
              </div>
              <div className="customer-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="customer-list-view-details-view-box-full-info-data-section-main">
                  Modified By
                </div>
                <div className="customer-list-view-details-view-box-full-info-data-section-sub">
                  {customerDetails?.updatedBy || "-"}
                  <br />
                  {formatDateTime(customerDetails?.updated_at || "-", true)}
                </div>
              </div>
            </div>

            <div className="customer-list-view-details-view-box-full-info-data-section">
              <div className="customer-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="customer-list-view-details-view-box-full-info-data-section-main">
                  Secondary Email
                </div>
                <ContactLink
                  type="Email"
                  value={customerDetails?.secondary_email_address || "-"}
                  id={customerDetails?.id}
                  className="customer-list-view-details-view-box-full-info-data-section-sub"
                />
              </div>
              <div className="customer-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="customer-list-view-details-view-box-full-info-data-section-main">
                  Company
                </div>
                <div className="customer-list-view-details-view-box-full-info-data-section-sub">
                  {customerDetails?.company || "-"}
                </div>
              </div>
              <div className="customer-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="customer-list-view-details-view-box-full-info-data-section-main">
                  Assistant Phone Number
                </div>
                <ContactLink
                  type="Phone"
                  value={customerDetails?.assistant_phone_number || "-"}
                  id={customerDetails?.id}
                  className="customer-list-view-details-view-box-full-info-data-section-sub"
                />
              </div>  
               <div className="customer-list-view-details-view-box-full-info-data-section-main-sub">
                <div className="customer-list-view-details-view-box-full-info-data-section-main">
                  Preferred Contact Mode
                </div>
                <div className="customer-list-view-details-view-box-full-info-data-section-sub">
                  {customerDetails?.preferred_contact_mode || "-"}
                </div>
              </div>          
            </div>
          </div>
          <div className="customer-list-view-details-view-box-full-info-header-text">
            Description
          </div>
          <div className="customer-list-view-details-view-box-full-info-description-box description-box-container">
            {customerDetails?.description || "-"}
          </div>
        </>
      ) : (
        ""
      )}
    </div>
  );
};

export default LeadViewDetailsViewFullInfo;
